var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97496 8.5252L0.627372 8.5252C0.371629 8.5252 0.16255 8.31759 0.166812 8.06188C0.167767 8.00459 0.168882 7.97188 0.169944 7.95195C0.183808 7.69193 0.379005 7.47741 0.639395 7.47741L6.97496 7.47741L6.97496 1.12981C6.97496 0.874069 7.18228 0.666748 7.43802 0.666748L7.55969 0.666748C7.81543 0.666748 8.02276 0.874069 8.02276 1.12981L8.02275 7.47741L14.3703 7.47741C14.6261 7.47741 14.8334 7.68473 14.8334 7.94047V8.06214C14.8334 8.31788 14.6261 8.5252 14.3704 8.5252L8.02275 8.5252L8.02275 14.8728C8.02275 15.1285 7.81514 15.3376 7.55943 15.3333C7.50214 15.3324 7.46943 15.3313 7.4495 15.3302C7.18947 15.3164 6.97496 15.1212 6.97496 14.8608L6.97496 8.5252Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.90f27b71.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97496 8.5252L0.627372 8.5252C0.371629 8.5252 0.16255 8.31759 0.166812 8.06188C0.167767 8.00459 0.168882 7.97188 0.169944 7.95195C0.183808 7.69193 0.379005 7.47741 0.639395 7.47741L6.97496 7.47741L6.97496 1.12981C6.97496 0.874069 7.18228 0.666748 7.43802 0.666748L7.55969 0.666748C7.81543 0.666748 8.02276 0.874069 8.02276 1.12981L8.02275 7.47741L14.3703 7.47741C14.6261 7.47741 14.8334 7.68473 14.8334 7.94047V8.06214C14.8334 8.31788 14.6261 8.5252 14.3704 8.5252L8.02275 8.5252L8.02275 14.8728C8.02275 15.1285 7.81514 15.3376 7.55943 15.3333C7.50214 15.3324 7.46943 15.3313 7.4495 15.3302C7.18947 15.3164 6.97496 15.1212 6.97496 14.8608L6.97496 8.5252Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.90f27b71.svg";
export { ForwardRef as ReactComponent };